import {
  FpSidebarGroup,
  FpSidebarGroupContent,
  FpSidebarMenu,
  FpSidebarMenuButton,
  FpSidebarMenuItem,
} from "@/components/ui/fp-sidebar";
import { listChatsQueryOptions } from "@/lib/hooks/useChats";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";

const inactiveProps = {
  className: "text-muted-foreground",
};

const activeProps = {
  className: "text-foreground bg-secondary",
};

export function RecentItems() {
  const { data } = useQuery(listChatsQueryOptions());
  const chats = data?.chats ?? [];

  return (
    <FpSidebarGroup className="flex-1 min-h-0">
      <div className="px-4 pb-2">
        <h2 className="text-base font-medium group-data-[collapsible=icon]:hidden">
          Recent Chats
        </h2>
      </div>
      <FpSidebarGroupContent className="flex-1 overflow-y-auto">
        <FpSidebarMenu className="px-4">
          {chats.map((chat) => (
            <FpSidebarMenuItem key={chat.id}>
              <FpSidebarMenuButton
                asChild
                className="p-2 text-base transition-colors hover:bg-muted rounded-xl truncate h-auto"
              >
                <Link
                  to="/codegen/$chatId"
                  params={{ chatId: chat.id }}
                  className="block"
                  activeProps={activeProps}
                  inactiveProps={inactiveProps}
                >
                  {chat.summary || "New chat"}
                </Link>
              </FpSidebarMenuButton>
            </FpSidebarMenuItem>
          ))}
        </FpSidebarMenu>
      </FpSidebarGroupContent>
    </FpSidebarGroup>
  );
}
